import { UserMgtSvcClientv3 } from '@jarvis/web-stratus-client';

export const TOU_CONSENT_STORAGE_KEY = 'smbDashboardTouConsent';

// Bump this value whenever the Terms of Use content changes to force every user to accept the new terms again.
export const CURRENT_TOU_VERSION = 'tou-v1';

const isValidConsentState = state => typeof state === 'object' && state !== null && !Array.isArray(state);

export const getTouConsentState = () => {
  try {
    const storedValue = localStorage?.getItem(TOU_CONSENT_STORAGE_KEY);
    if (!storedValue) {
      return {};
    }

    const parsedValue = JSON.parse(storedValue);
    return isValidConsentState(parsedValue) ? parsedValue : {};
  } catch {
    return {};
  }
};

export const resolveTouUserKey = currentActiveUserResponse => {
  const userResourceId = currentActiveUserResponse?.data?.resourceId;
  return userResourceId ? String(userResourceId) : null;
};

export const getCurrentTouUserKey = async ({ authProvider, stack }) => {
  if (!authProvider || typeof stack !== 'number') {
    return null;
  }

  const userClient = new UserMgtSvcClientv3(stack, authProvider);
  const currentActiveUser = await userClient.getCurrentActiveUser();

  return resolveTouUserKey(currentActiveUser);
};

export const hasTouConsent = userKey => {
  if (!userKey) {
    return false;
  }

  const consentState = getTouConsentState();
  return consentState[userKey] === CURRENT_TOU_VERSION;
};

export const setTouConsent = userKey => {
  if (!userKey) {
    return false;
  }

  const consentState = getTouConsentState();

  try {
    localStorage?.setItem(TOU_CONSENT_STORAGE_KEY, JSON.stringify({
      ...consentState,
      [userKey]: CURRENT_TOU_VERSION,
    }));
  } catch {
    return false;
  }

  return true;
};
